import {
  ModuleListWrapper,
  ListDivider,
  EditIconContainer,
  EmailUser,
  UserInfoContainer,
  ItemContainer,
  ModuleTitle,
  IconWrapper,
  IconListContainer,
} from "../StylesCatalogs";

import {
  UsersIcon,
  ClientIcon,
  ExpertIcon,
  AdapterIcon,
  BranchesIcon,
  CoinIcon,
  PencilIcon,
  TrashIcon,
} from "../../../assets/icons/Icons";

export default function index({
  viewModal,
  dataToMap,
  setCurrentId,
  valueToSearch,
}) {
  const { catalogView, users, clients, experts, fixers, branches, exchange } =
    dataToMap;
  const {
    setShowModalEditUser,
    setShowModalDeleteUser,
    setShowModalEditExpert,
    setShowModalEditAdapter,
    setShowModalEditBranch,
    setShowModalEditCoin,
    setShowModalEditClient,
    setShowModalDeleteClient,
    setShowModalDeleteExpert,
    setShowModalDeleteAdapter,
    setShowModalDeleteBranch,
    setShowModalDeleteCoin,
  } = viewModal;

  function viewModalEditUser(id) {
    setShowModalEditUser(true);
    setCurrentId(id);
  }

  function viewModalDeleteUser(id) {
    setShowModalDeleteUser(true);
    setCurrentId(id);
  }

  function viewModalEditExpert(experto_id) {
    setShowModalEditExpert(true);
    setCurrentId(experto_id);
  }

  function viewModalEditAdapter(id) {
    setShowModalEditAdapter(true);
    setCurrentId(id);
  }

  function viewModalEditBranch(id) {
    setShowModalEditBranch(true);
    setCurrentId(id);
  }

  function viewModalEditCoin(id) {
    setShowModalEditCoin(true);
    setCurrentId(id);
  }

  function viewModalEditClient(id) {
    setCurrentId(id);
    setShowModalEditClient(true);
  }

  function viewModalDeleteClient(id) {
    setCurrentId(id);
    setShowModalDeleteClient(true);
  }

  function viewModalDeleteExpert(experto_id) {
    setShowModalDeleteExpert(true);
    setCurrentId(experto_id);
  }

  function viewModalDeleteAdapter(id) {
    setShowModalDeleteAdapter(true);
    setCurrentId(id);
  }

  function viewModalDeleteBranch(id) {
    setShowModalDeleteBranch(true);
    setCurrentId(id);
  }

  function viewModalDeleteCoin(id) {
    setShowModalDeleteCoin(true);
    setCurrentId(id);
  }

  return (
    <ModuleListWrapper>
      {catalogView === "Users" && (
        <>
          {users.length === 0 ? (
            <ModuleTitle>No se encontraron usuarios</ModuleTitle>
          ) : (
            <>
              {users
                .filter((obj) => {
                  return Object.values(obj).some((val) =>
                    val
                      ?.toString()
                      ?.toUpperCase()
                      .includes(valueToSearch?.toUpperCase())
                  );
                })
                .map(({ name, email, usuario_id }, id) => (
                  <>
                    <ItemContainer id={id}>
                      <IconWrapper>
                        <IconListContainer>
                          <UsersIcon />
                        </IconListContainer>
                        <UserInfoContainer>
                          <p>{name}</p>
                          <EmailUser>{email}</EmailUser>
                        </UserInfoContainer>
                      </IconWrapper>
                      <EditIconContainer>
                        <div
                          onClick={() => {
                            viewModalEditUser(usuario_id);
                          }}
                        >
                          <PencilIcon />
                        </div>
                        <div
                          onClick={() => {
                            viewModalDeleteUser(usuario_id);
                          }}
                        >
                          <TrashIcon />
                        </div>
                      </EditIconContainer>
                    </ItemContainer>
                    <ListDivider />
                  </>
                ))}
            </>
          )}
        </>
      )}
      {catalogView === "Clients" && (
        <>
          {clients.length === 0 ? (
            <ModuleTitle>No se encontraron clientes</ModuleTitle>
          ) : (
            <>
              {clients
                .filter((obj) => {
                  return Object.values(obj).some((val) =>
                    val?.toUpperCase().includes(valueToSearch?.toUpperCase())
                  );
                })
                .map((client, id) => (
                  <>
                    <ItemContainer id={id}>
                      <IconWrapper>
                        <IconListContainer>
                          <ClientIcon />
                        </IconListContainer>
                        <UserInfoContainer>
                          <p>{client.nombre}</p>
                        </UserInfoContainer>
                      </IconWrapper>
                      <EditIconContainer>
                        <div
                          onClick={() => {
                            viewModalEditClient(client.cliente_id);
                          }}
                        >
                          <PencilIcon />
                        </div>
                        <div
                          onClick={() => {
                            viewModalDeleteClient(client.cliente_id);
                          }}
                        >
                          <TrashIcon />
                        </div>
                      </EditIconContainer>
                    </ItemContainer>
                    <ListDivider />
                  </>
                ))}
            </>
          )}
        </>
      )}
      {catalogView === "Experts" && (
        <>
          {experts.length === 0 ? (
            <ItemContainer>
              <ModuleTitle>No se encontraron expertos</ModuleTitle>
            </ItemContainer>
          ) : (
            <>
              {experts
                .filter((obj) => {
                  return Object.values(obj).some((val) =>
                    val?.toUpperCase().includes(valueToSearch?.toUpperCase())
                  );
                })
                .map(({ name, company, experto_id }, id) => (
                  <>
                    <ItemContainer id={id}>
                      <IconWrapper>
                        <IconListContainer>
                          <ExpertIcon />
                        </IconListContainer>
                        <UserInfoContainer>
                          <p>{company}</p>
                          <EmailUser>{name}</EmailUser>
                        </UserInfoContainer>
                      </IconWrapper>
                      <EditIconContainer>
                        <div
                          onClick={() => {
                            viewModalEditExpert(experto_id);
                          }}
                        >
                          <PencilIcon />
                        </div>
                        <div
                          onClick={() => {
                            viewModalDeleteExpert(experto_id);
                          }}
                        >
                          <TrashIcon />
                        </div>
                      </EditIconContainer>
                    </ItemContainer>
                    <ListDivider />
                  </>
                ))}
            </>
          )}
        </>
      )}
      {catalogView === "Fixers" && (
        <>
          {fixers.length === 0 ? (
            <ModuleTitle>No se encontraron ajustadores</ModuleTitle>
          ) : (
            <>
              {fixers
                .filter((obj) => {
                  return Object.values(obj).some((val) =>
                    val?.toUpperCase().includes(valueToSearch?.toUpperCase())
                  );
                })
                .map(({ name, company, ajustador_id }, id) => (
                  <>
                    <ItemContainer id={id}>
                      <IconWrapper>
                        <IconListContainer>
                          <AdapterIcon />
                        </IconListContainer>
                        <UserInfoContainer>
                          <p>{company}</p>
                          <EmailUser>{name}</EmailUser>
                        </UserInfoContainer>
                      </IconWrapper>
                      <EditIconContainer>
                        <div
                          onClick={() => {
                            viewModalEditAdapter(ajustador_id);
                          }}
                        >
                          <PencilIcon />
                        </div>
                        <div
                          onClick={() => {
                            viewModalDeleteAdapter(ajustador_id);
                          }}
                        >
                          <TrashIcon />
                        </div>
                      </EditIconContainer>
                    </ItemContainer>
                    <ListDivider />
                  </>
                ))}
            </>
          )}
        </>
      )}
      {catalogView === "Branches" && (
        <>
          {branches.length === 0 ? (
            <ModuleTitle>No se encontraron ramos</ModuleTitle>
          ) : (
            <>
              {branches
                .filter((obj) => {
                  return Object.values(obj).some((val) =>
                    val?.toUpperCase().includes(valueToSearch?.toUpperCase())
                  );
                })
                .map((value, id) => (
                  <>
                    <ItemContainer id={id}>
                      <IconWrapper>
                        <IconListContainer>
                          <BranchesIcon />
                        </IconListContainer>
                        <UserInfoContainer>
                          <p>{value.nombre} </p>
                        </UserInfoContainer>
                      </IconWrapper>
                      <EditIconContainer>
                        <div
                          onClick={() => {
                            viewModalEditBranch(value.ramo_id);
                          }}
                        >
                          <PencilIcon />
                        </div>
                        <div
                          onClick={() => {
                            viewModalDeleteBranch(value.ramo_id);
                          }}
                        >
                          <TrashIcon />
                        </div>
                      </EditIconContainer>
                    </ItemContainer>
                    <ListDivider />
                  </>
                ))}
            </>
          )}
        </>
      )}
      {catalogView === "Coin" && (
        <>
          {exchange.length === 0 ? (
            <ModuleTitle>No se encontraron monedas</ModuleTitle>
          ) : (
            <>
              {exchange
                .filter((obj) => {
                  return Object.values(obj).some((val) =>
                    val?.toUpperCase().includes(valueToSearch?.toUpperCase())
                  );
                })
                .map((value, id) => (
                  <>
                    <ItemContainer id={id}>
                      <IconWrapper>
                        <IconListContainer>
                          <CoinIcon />
                        </IconListContainer>
                        <UserInfoContainer>
                          <p>{value.nombre} </p>
                        </UserInfoContainer>
                      </IconWrapper>
                      <EditIconContainer>
                        <div
                          onClick={() => {
                            viewModalEditCoin(value.tipo_cambio_id);
                          }}
                        >
                          <PencilIcon />
                        </div>
                        <div
                          onClick={() => {
                            viewModalDeleteCoin(value.tipo_cambio_id);
                          }}
                        >
                          <TrashIcon />
                        </div>
                      </EditIconContainer>
                    </ItemContainer>
                    <ListDivider />
                  </>
                ))}
            </>
          )}
        </>
      )}
    </ModuleListWrapper>
  );
}
